module.exports = __webpack_public_path__ + "static/media/ProfilePic.c391ddc0.png";